import { render } from "./ElementalResonanceInput.vue?vue&type=template&id=4990f2e0&scoped=true&ts=true"
import script from "./ElementalResonanceInput.vue?vue&type=script&lang=ts"
export * from "./ElementalResonanceInput.vue?vue&type=script&lang=ts"

import "./ElementalResonanceInput.vue?vue&type=style&index=0&id=4990f2e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4990f2e0"]])

export default __exports__